import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRotateClockwise: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowRotateClockwise"><Path d="M20 9H14V7H16.8955C15.6324 5.76315 13.9056 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.2602 19 18.0021 16.7702 18.7793 13.751L20.7168 14.249C19.7178 18.1306 16.195 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C14.3058 3 16.4084 3.86733 18 5.29199V3H20V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowRotateClockwise;
